const WhatIsRealTimePoR = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-primary-900 via-primary-800 to-primary-900 text-white section-padding">
      <div className="container-custom relative z-10">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-center mb-4 text-accent-400">
          What is Real-Time Proof of Reserves?
        </h2>
        <p className="text-lg sm:text-xl text-center text-gray-300 mb-12 sm:mb-16">
          Tech-enabled Attestation Reporting
        </p>

        <div className="relative bg-gradient-to-br from-accent-600 to-accent-800 rounded-3xl p-6 sm:p-8 md:p-12 overflow-hidden">
          {/* Badge */}
          <div className="absolute top-6 sm:top-8 left-1/2 -translate-x-1/2 bg-primary-800 border-2 border-accent-400 rounded-full px-4 sm:px-6 py-2 text-xs sm:text-sm font-semibold text-white shadow-lg z-10 w-max max-w-[90%]">
            Real Time CPA Attest Reporting Available for Download on Demand
          </div>

          {/* Image Background */}
          <div className="mt-20 sm:mt-16 relative min-h-[300px] sm:min-h-[400px] flex items-center justify-center">
            <img
              src="/1.jpg"
              alt="Real-Time CPA Attestation"
              className="w-full h-auto max-w-3xl rounded-2xl shadow-2xl object-cover"
            />
          </div>

          {/* Bottom text box */}
          <div className="mt-6 sm:mt-8 bg-primary-900/50 backdrop-blur-sm border border-accent-400/30 rounded-2xl p-6">
            <h3 className="text-lg sm:text-xl font-bold text-white mb-2">Real Time CPA Attest Reporting</h3>
            <p className="text-sm sm:text-base text-gray-300">
              AUP or Examination Opinion from CPA covers reserve assets and token holder or noteholder liabilities.
            </p>
            <div className="mt-4 flex items-center gap-2">
              <svg className="w-6 h-6 text-green-400" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
              <span className="font-semibold">Verified & Secure</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatIsRealTimePoR;
